import { jsxs, jsx } from 'react/jsx-runtime.js';
import React__default, { useMemo } from 'react';
import styles from './Skeleton.module.css.js';

var STEP = 200;
var Skeleton = /*#__PURE__*/React__default.memo(function (props) {
  var _props$circle = props.circle,
    circle = _props$circle === void 0 ? false : _props$circle,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    height = props.height,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    width = props.width;
  var skeletonStyle = circle ? {
    borderRadius: "50%",
    height: outerRadius ? outerRadius * 2 : undefined,
    width: outerRadius ? outerRadius * 2 : undefined
  } : {
    height: height,
    width: width
  };
  var backgroundStyle = circle ? {
    height: outerRadius ? outerRadius * 2 : undefined,
    width: outerRadius ? outerRadius * 2 + STEP : undefined
  } : {
    height: height,
    width: width ? width + STEP : undefined
  };
  var innerCircleStyle = useMemo(function () {
    if (circle && innerRadius && outerRadius) {
      var innRad = Math.min(innerRadius, outerRadius);
      return {
        height: innRad * 2,
        left: outerRadius - innRad + 'px',
        top: outerRadius - innRad + 'px',
        width: innRad * 2
      };
    } else {
      return {
        display: 'none'
      };
    }
  }, [circle, innerRadius, outerRadius]);
  return jsxs("div", {
    className: "".concat(styles.container, " ").concat(className),
    style: skeletonStyle,
    children: [jsx("div", {
      className: styles.background,
      style: backgroundStyle
    }), jsx("div", {
      className: styles.innerCircle,
      style: innerCircleStyle
    })]
  });
});

export { Skeleton };
